<template>
  <div class="center-box">
    <CenterLineChart style="margin-right: 36px"></CenterLineChart>

    <div class="ranking-car">
      <div class="title">各车型使用情况</div>
      <dv-capsule-chart :config="config" style="width: 314px; height: 250px" />
    </div>

    <FootPieChart></FootPieChart>
  </div>
</template>

<script>
import { getModelUsage } from '../../../api/colunm3'
import CenterLineChart from './CenterLineChart.vue'
import FootPieChart from './CenterPieChart.vue'
export default {
  components: {
    CenterLineChart,
    FootPieChart
  },

  props: {
    price: Array
  },

  data () {
    return {
      timer1: null,
      config: {
        data: [],
        colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
        unit: '',
        showValue: true
      },
      timer: null
    }
  },

  created () {
    this.getPageData()
  },

  methods: {
    getPageData () {
      getModelUsage().then(res => {
        const data = []
        res.forEach(element => {
          element.value = Math.floor(element.value)
          data.push(element)
        })
        this.config.data = data
        this.config = { ...this.config }
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getPageData, 1000 * 10)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.center-box {
  display: flex;
  justify-content: space-between;
  height: 301px;
}
.ranking-car {
  width: 314px;
  height: 301px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .title {
    width: 100%;
    padding: 10px 0 0 15px;
    color: #34DEE5;
    font-size: 21px;
    font-weight: bold;
  }
  align-items: flex-end;
  /deep/ .dv-capsule-chart {
    padding-left: 0;
  }
  /deep/ .unit-label {
    display: none;
  }
  /deep/ .label-column {
    div:last-child {
      display: none;
    }
  }
}
</style>